import docCookies from 'doc-cookies';

export default () => ({
  id: '',
  open: false,
  reviews: [],
  ratingSent: false,

  openModal() {
    this.id = this.$event.detail;
    this.open = true;
    this.$dispatch('radio:unset');
    this.reviews = docCookies.getItem('reviews')
      ? JSON.parse(docCookies.getItem('reviews'))
      : [];
    this.ratingSent = this.reviews.includes(this.id);
  },

  setCookie(sent) {
    if (sent) {
      this.reviews.push(this.id);
      docCookies.setItem('reviews', JSON.stringify(this.reviews));
    }
  },

  init() {},
});
